import { StudentsPage } from "./students";

export default function ArchivedStudents() {
  return <StudentsPage archivedView />;
}
